<template>
  <v-app light>
    <v-toolbar app clipped-left fixed tabs prominent dark color="teal darken-3">
      <v-btn icon @click.native="cancel">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-text="'Gráficos'"></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-formulario>
        <v-content>
          <panel-graficos-rebanho :vare="none" class="panelGrafico" id="graficos_do_rebanho" />
          <panel-graficos-depreciacaoes-juros :vare="none" class="panelGrafico" />
          <panel-graficos-receita :vare="none" class="panelGrafico" id="graficos_das_receitas" />
          <panel-graficos-custos :vare="none" class="panelGrafico" />
          <panel-graficos-margem-economica :vare="none" class="panelGrafico" />
        </v-content>
        <!-- Botão de reduzir os painéis-->
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              absolute
              fab
              transition="slide-y-reverse-transition"
              right
              dark
              color="teal"
              @click="muda()"
              class="botaoNone"
            >
              <v-icon dark>keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <span>Fechar Painéis</span>
        </v-tooltip>
      </v-formulario>
    </v-content>
  </v-app>
</template>
<script>
import PanelGraficosRebanho from "../components/panel/PanelGraficosRebanho.vue";
import PanelGraficosReceita from "../components/panel/PanelGraficosReceita.vue";
import PanelGraficosDespesasDepreciacoesJuros from "../components/panel/PanelGraficosDespesasDepreciacoesJuros.vue";
import PanelGraficosCustos from "../components/panel/PanelGraficosCustos.vue";
import PanelGraficosMargensEconomicas from "../components/panel/PanelGraficosMargensEconomicas.vue";
import UtilHelper from '../helpers/util';
export default {
  components: {
    "panel-graficos-rebanho": PanelGraficosRebanho,
    "panel-graficos-receita": PanelGraficosReceita,
    "panel-graficos-depreciacaoes-juros": PanelGraficosDespesasDepreciacoesJuros,
    "panel-graficos-custos": PanelGraficosCustos,
    "panel-graficos-margem-economica": PanelGraficosMargensEconomicas
  },
  mixins: [
    UtilHelper
  ],
  data: () => ({
    forme: "",
    none: 0,
    snackbar: false,
    panel: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    text: "Todos os painéis estão fechados!",
    simulation: null
  }),

  beforeMount () {
    this.simulation = this.instantiateSimulationHelper()
  },
  mounted () {
    var self = this
    this.$db.simulation.get(this.$route.params.code, function (s) {
      self.simulation = s
    })
  },

  methods: {
    muda() {
      if (this.none == 0) {
        this.none = 1;
      } else {
        this.none = 0;
      }
    },
    cancel () {
      this.$router.push({ path: '/home' })
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>